import React from 'react';
import { Button, Modal, Checkbox } from 'semantic-ui-react'
import TagComponent from '../tag_component'

class UpdateTagsModal extends TagComponent {
  constructor(props){
    super(props);
    this.state = {
      tagged_item: props.tagged_item
    }

  }

  onCheckboxChange = (evt, data) => {
    if(data.checked){
      this.onAdd(data)
    }else {
      this.onRemove(data)
    }
  }

  onAdd = (data) => {
    var tagged_item = this.state.tagged_item
    if(data.context === 'tags' && data.value.length > 0){
      this.addToTagList(data.value, tagged_item)
    }
    else if(data.context === 'regions' && data.value.length > 0){
      this.addToRegionList(data.value, tagged_item)
    }
    this.setState({
      tagged_item: tagged_item
    })
  }

  onRemove = (data) => {
    var tagged_item = this.state.tagged_item
    if (data.context === 'tags'){
      this.removeFromTagList(data.value, tagged_item)
    }
    else if (data.context === 'regions'){
      this.removeFromRegionList(data.value, tagged_item)
    }

    this.setState({
      tagged_item: tagged_item
    })
  }

  render() {
    const { show, onClose, tags, regions} = this.props
    const { tagged_item } = this.state
    return (
      <Modal className="update-tags" size='tiny' dimmer='inverted' open={ show } >
        <Modal.Header>Edit Tags</Modal.Header>
        <Modal.Content scrolling>
          <div className='row'>
            <div className="col-sm-6">
              <div role="list" className="ui list">
                <h4>Region Tags</h4>
                {
                  regions.map((region, index)=>{
                    if(region.value.length > 0){
                      return(
                        <div role="listitem" className="item" key={index}>
                          <div className='content'>
                            <Checkbox
                              className='team-checkbox'
                              context='regions'
                              label={<label><div className="ui label region">{region.value}</div></label>}
                              value={region.value}
                              checked={tagged_item.region_list.includes(region.value)}
                              onChange={this.onCheckboxChange}
                            />
                          </div>
                        </div>
                      )
                    }
                    else return true
                  })
                }
              </div>
            </div>
            <div className="col-sm-6">
              <div role="list" className="ui list">
                <h4>Team Tags</h4>
                {
                  tags.map((tag, index)=>{
                    if(tag.value.length > 0){
                      return(
                        <div role="listitem" className="item" key={index}>
                          <div className='content'>
                            <Checkbox
                              className='team-checkbox'
                              context='tags'
                              label={<label><div className="ui label">{tag.value}</div></label>}
                              value={tag.value}
                              checked={tagged_item.tag_list.includes(tag.value)}
                              onChange={this.onCheckboxChange}
                            />
                          </div>
                        </div>
                      )
                    }
                    else return true
                  })
                }
              </div>
            </div>
          </div>

        </Modal.Content>
        <Modal.Actions>
          <Button
            color='teal'
            content="Close"
            onClick={ (evt) => onClose() }
          />
        </Modal.Actions>
      </Modal>
    )
  }
}
export default UpdateTagsModal;



// WEBPACK FOOTER //
// ./src/views/components/modals/update_tags.js